import { Button, Skeleton, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import React, { useMemo } from 'react';
import { loadableEnum } from '../../../common/useMakePHPRequest';
import { IUserAtom } from '../../../recoil/atoms/user';
import { ModalWithStyles } from '../../components/modals/ModalWithStyles';

import {
  spProductPricingEntity,
  useGetAllBusinessProductsFromDIDQuery,
} from '../../../api/apigQuery';

import { getPriceAndCycle } from '../../pages/ManageNumbers';

const useStyles = makeStyles((theme: Theme) => ({
  skeleton: {
    backgroundColor: theme.palette.mode === 'dark' ? 'grey' : 'lightgrey',
    height: '6em',
    margin: 10,
  },
  buttonContainedRed: {
    color: theme?.custom?.button?.delete?.contrastText,
    backgroundColor: theme?.custom?.button?.delete?.main,
    marginLeft: theme.spacing(1), // space between fields
    '&:hover': {
      backgroundColor: theme?.custom?.button?.delete?.dark,
    },
  },
}));
interface ConfirmDeleteProps {
  price: number;
  billingCycle: number;
  deleteStatus: string;
  showConfirmDelete: boolean;
  setShowConfirmDelete: React.Dispatch<React.SetStateAction<boolean>>;
  rowForDelete: Record<string, any>;
  deleteNumber: (event: any, params: any) => Promise<void>;
  userAtomContents: IUserAtom;
  productData: {
    localLine: spProductPricingEntity;
    tollFreeLine: spProductPricingEntity;
  };
}
export const ConfirmDeleteNumberModal = ({
  deleteStatus,
  showConfirmDelete,
  setShowConfirmDelete,
  rowForDelete,
  deleteNumber,
  userAtomContents,
}: ConfirmDeleteProps) => {
  const classes = useStyles();
  const {
    currentData: productDataRes,
    isLoading,
  } = useGetAllBusinessProductsFromDIDQuery({
    userSettings: {
      userId: userAtomContents?.userid,
      userid: userAtomContents?.userid,
      businessId: userAtomContents?.businessid,
      businessid: userAtomContents?.businessid,
      apikey: userAtomContents?.apikey,
    },
    did: rowForDelete?.data?.DID,
  });
  const pricingData = productDataRes?.pricingData;
  const description = productDataRes?.description;
  const productDataMemo = useMemo(() => {
    const d = pricingData ?? [];
    return {
      localLine: d?.filter((p) => p.product === 'localtrackingline')?.[0],
      tollFreeLine: d?.filter((p) => p.product === 'tollfreetrackingline')?.[0],
    };
  }, [productDataRes]);

  const { price, billingCycle } = getPriceAndCycle(
    productDataMemo,
    description
  );
  return (
    <ModalWithStyles
      title={`Delete Number - ${rowForDelete?.data?.DID ?? ''} `}
      aria-labelledby="modal-lg-delete-number"
      show={showConfirmDelete}
      onHide={() => setShowConfirmDelete(false)}
      isLoading={deleteStatus === loadableEnum.LOADING || isLoading}
      size="xs"
      footerComponent={
        <>
          <Button
            variant="contained"
            disableElevation={true}
            onClick={() => setShowConfirmDelete(false)}
          >
            Cancel
          </Button>
          <Button
            className={clsx(classes.buttonContainedRed)}
            color="primary"
            variant="contained"
            disableElevation={true}
            onClick={async (e) => await deleteNumber(e, rowForDelete)}
          >
            Delete
          </Button>
        </>
      }
    >
      {isLoading ? (
        <>
          <Skeleton variant="text" height={30} />
          <Skeleton variant="text" height={30} />
          <Skeleton variant="text" height={30} />
          <Skeleton variant="text" height={30} />
        </>
      ) : (
        <>
          <p>
            {`You are about to delete a  Kixie Number ${
              rowForDelete?.data?.DID ?? ''
            } from your account.`}
          </p>
          <p>
            {`A Phone Number product in the amount of
            $${price} per ${billingCycle === 1 ? '' : billingCycle} month${
              billingCycle === 1 ? '' : 's'
            } will be removed from future invoices.`}
          </p>
          <p>Are you sure you want to continue?</p>
        </>
      )}
    </ModalWithStyles>
  );
};
